import {setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {RoomClientState} from '../RoomClientState.ts'
import {socket} from '../EntryShared'
import {UIRoomCenterSettingsSpeedView} from './UIRoomCenterSettingsSpeedView'
import {GameSpeedSettings} from '@colonist/types'
import {TranslationKeys} from '@colonist/i18n'
import {PlayerEnums} from '../../../../shared/GameEnums.ts'

export class UIRoomCenterSettingsSpeedController {
    private readonly view: UIRoomCenterSettingsSpeedView
    private _currentSetting: GameSpeedSettings

    constructor(container: HTMLDivElement) {
        this.view = new UIRoomCenterSettingsSpeedView(container)
        this.currentSetting = this.view.speedDefaultSetting
    }

    get currentSetting(): GameSpeedSettings {
        return this._currentSetting
    }

    set currentSetting(value: GameSpeedSettings) {
        this._currentSetting = value
        const option = this.view.speedOptions.find((o) => o === value)
        const labelKey: TranslationKeys = option != undefined ? PlayerEnums.getSpeedSettingText(option).key as TranslationKeys : 'strings:colonistCommon.utils.bug'
        setElementInnerHTML(this.view.speedInput, {key: labelKey})
    }

    update(newRoomState: RoomClientState) {
        this.view.updateOptions(newRoomState)
        this.currentSetting = newRoomState.gameSetting.gameSpeed

        this.view.container.classList.toggle('selected', this.currentSetting != this.view.speedDefaultSetting)
    }

    load(roomState: RoomClientState) {
        this.initSpeedSettings(roomState)
    }

    private initSpeedSettings(roomState: RoomClientState) {
        const {
            speedDivBody: footerDiv,
            speedRightArrow: rightArrow,
            speedLeftArrow: leftArrow,
            speedSocketCommand: socketCommand,
        } = this.view

        if(UIRoomCenterSettingsSpeedController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest'
            rightArrow.classList.toggle('hidden', true)
            leftArrow.classList.toggle('hidden', true)
            setElementOnClick(rightArrow, () => undefined)
            setElementOnClick(leftArrow, () => undefined)
            return
        }
        footerDiv.className = 'option_body'
        leftArrow.classList.toggle('hidden', false)
        rightArrow.classList.toggle('hidden', false)
        setElementOnClick(leftArrow, () => {
            const optionsArray = this.view.speedOptions
            const currentIndex = optionsArray.findIndex((o) => o === this.currentSetting)
            let newIndex = currentIndex - 1
            if(newIndex < 0) newIndex = optionsArray.length - 1
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })

        setElementOnClick(rightArrow, () => {
            const optionsArray = this.view.speedOptions
            const currentIndex = optionsArray.findIndex((o) => o === this.currentSetting)
            let newIndex = currentIndex + 1
            if(newIndex >= optionsArray.length) newIndex = 0
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        })
    }

    updateInteractabilityOfElements(roomState: RoomClientState) {
        this.load(roomState)
    }

    private static isGuest(roomState: RoomClientState): boolean {
        return socket.controller.session.id != roomState.hostSession.userSessionId
    }
}
